// extracted by mini-css-extract-plugin
export default {"head":"Hamper_head__JdMf9","hamper":"Hamper_hamper__Ccj6H","linkscard":"Hamper_linkscard__HD-Ip","links":"Hamper_links__yRpbP"};